import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {
  makeStyles,
  Grid,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Button,
} from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { useSelector, useDispatch } from 'react-redux'
import Portlet from '~/components/Portlet'
import RhfTextField from '~/components/FormComponents/RhfTextField'

import { Creators as EquipmentActions } from '~/store/ducks/equipment'
import { Creators as FlashMessageActions } from '~/store/ducks/flashMessage'

import sanitizeHtml from '~/helpers/sanitizeHtml'
import styles from './styles'

const useStyles = makeStyles(styles)
const userSelector = ({ session: { user } }) => user
const historiesSelector = ({ equipment: { histories } }) => histories

export default function EquipmentHistoryFormTab({ onClose, id }) {
  const classes = useStyles()
  const dispatch = useDispatch()

  const user = useSelector(userSelector)
  const histories = useSelector(historiesSelector)

  const {
    control,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const handleClearForm = () => reset({})
  const handleSubmitForm = (data) => {
    const formattedData = {
      user_id: user.id || null,
      description: data.description || null,
      equipment_id: id,
    }
    dispatch(
      EquipmentActions.addEquipmentHistoryRequest(formattedData, () => {
        handleClearForm()
        dispatch(
          FlashMessageActions.showMessage({
            message: 'Ação salva com sucesso!',
            variant: 'success',
          }),
        )
      }),
    )
    onClose()
  }

  return (
    <div className={classes.root}>
      <>
        <form
          id="form-call-action"
          onSubmit={handleSubmit(handleSubmitForm)}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <RhfTextField
                defaultValue=""
                control={control}
                name="description"
                rules={{ required: true }}
                InputLabelProps={{
                  shrink: true,
                }}
                label="Descrição"
                multiline
                error={!!errors.description}
                helperText={!!errors.description && 'Campo obrigatório'}
                rows={4}
                placeholder="Informe a descrição para o equipamento"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Button
                type="button"
                variant="contained"
                onClick={() => handleClearForm()}
              >
                Limpar
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                type="submit"
                form="form-call-action"
              >
                Salvar ação
              </Button>
            </Grid>
          </Grid>
        </form>
        <Grid container>
          {!!histories?.data.length && (
            <Portlet className={classes.portlet}>
              <div className={classes.tableWrapper}>
                <div className={classes.listWrapper}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">Dt. cadastro</TableCell>
                        <TableCell align="center">Descrição</TableCell>
                        <TableCell align="center">Usuário</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {histories?.data.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell align="center">
                            {moment(item.created_at || '-').format(
                              'DD/MM/YYYY HH:mm',
                              'HH/MM',
                            )}
                          </TableCell>
                          <TableCell
                            align="left"
                            dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.description) }}
                          />
                          <TableCell align="left">
                            {item.user?.name}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </Portlet>
          )}
        </Grid>
      </>
    </div>
  )
}

EquipmentHistoryFormTab.propTypes = {
  onClose: PropTypes.func.isRequired,
  id: PropTypes.number,
}

EquipmentHistoryFormTab.defaultProps = {
  id: null,
}
